import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Wrench } from "lucide-react";
import { Nav } from "@/components/Nav";
import { Footer, WhatsAppFloat } from "@/components/landing/Footer";
import { ExpertCard } from "@/components/ExpertCard";
import { api } from "@/lib/api";

export default function Experts() {
  const [experts, setExperts] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/experts").then((r) => setExperts(r.data)).catch(() => setExperts([]));
  }, []);

  return (
    <div className="min-h-screen bg-obsidian" data-testid="experts-page">
      <Nav />
      <main className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto pt-32 pb-20">
        <p className="eyebrow mb-4">Directory Esperti</p>
        <h1 className="font-display text-2xl sm:text-4xl font-bold tracking-tight text-white max-w-2xl">
          I tecnici della piattaforma
        </h1>
        <p className="mt-3 text-slate-400 text-sm sm:text-base max-w-2xl">
          Meccanici, elettrauti e meccatronici verificati per auto, furgoni e camion.
          Apri un ticket e uno di loro lo prenderà in carico.
        </p>

        {experts === null ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            {[1, 2, 3].map((i) => (
              <div key={i} className="glass-card rounded-2xl h-52 animate-pulse" />
            ))}
          </div>
        ) : experts.length === 0 ? (
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            className="glass-card rounded-2xl p-10 text-center mt-12"
            data-testid="experts-empty"
          >
            <Wrench size={28} className="text-volt mx-auto mb-4" />
            <h2 className="font-display text-xl font-semibold text-white">Nessun esperto registrato — per ora</h2>
            <p className="mt-2 text-sm text-slate-400 max-w-md mx-auto">
              Sei un tecnico? Registrati e inizia a guadagnare con le consulenze:
              la piattaforma trattiene solo il 20% di commissione.
            </p>
            <button
              data-testid="experts-become-cta"
              onClick={() => navigate("/accedi?mode=register&role=esperto")}
              className="mt-6 bg-spark text-obsidian font-semibold text-sm px-6 py-3 rounded-full hover:scale-[1.03] transition-transform"
            >
              Diventa Esperto
            </button>
          </motion.div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12" data-testid="experts-grid">
            {experts.map((e) => (
              <ExpertCard key={e.user_id} expert={e} testid={`expert-card-${e.user_id}`} />
            ))}
          </div>
        )}
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
